export default function (idp: string | undefined) {
  return idp === 'trreb' || idp === 'trreb_amp';
}
